<template>
    <div class="bg-indigo-600" v-if="meta.info.bulletinsCount > 0">
        <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div class="flex items-center justify-between flex-wrap">
                <div class="w-0 flex-1 flex items-center">
                    <span class="flex p-2 rounded-lg bg-indigo-800">
                        <!-- Heroicon name: outline/speakerphone -->
                        <svg
                            class="h-6 w-6 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                            />
                        </svg>
                    </span>
                    <p class="ml-3 font-medium text-white truncate">
                        <span class="md:hidden">
                            {{
                                $tc('messages.X_school_bulletins', meta.info.bulletinsCount, {
                                    count: meta.info.bulletinsCount,
                                })
                            }}.
                        </span>
                        <span class="hidden md:inline">
                            {{
                                $tc('messages.X_school_bulletins', meta.info.bulletinsCount, {
                                    count: meta.info.bulletinsCount,
                                })
                            }}.
                        </span>
                    </p>
                </div>
                <div class="order-3 mt-2 shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                    <InertiaLink
                        :href="meta.links.bulletins_index"
                        class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50"
                    >
                        {{ $t('messages.show') }}
                    </InertiaLink>
                </div>
                <div class="order-2 shrink-0 sm:order-3 sm:ml-3">&nbsp;</div>
            </div>
        </div>
    </div>

    <div class="min-h-full">
        <div class="pt-2 pb-6 md:py-6">
            <div class="mx-auto md:px-4 sm:px-6 md:px-8">
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="md:col-span-1">
                        <div class="bg-white overflow-hidden sm:rounded-lg sm:shadow">
                            <img
                                :src="student.avatar_or_default"
                                alt="photo"
                                class="mx-auto rounded-full h-32 w-32 border-4 border-white"
                            />

                            <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                                <div class="flex flex-col justify-center items-center">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                                        {{ student.first_name }}
                                    </h3>
                                    <h3 class="leading-6 font-base text-gray-600">
                                        {{ $t('messages.student') }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 md:mt-0 md:col-span-2">
                        <div class="shadow sm:rounded-md sm:overflow-hidden">
                            <div class="px-4 py-5 bg-white sm:p-6">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <tbody class="bg-white divide-y divide-gray-200">
                                        <tr>
                                            <td
                                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                            >
                                                {{ $t('messages.first_name') }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                {{ student.first_name }}
                                            </td>
                                        </tr>

                                        <!-- More rows... -->

                                        <tr>
                                            <td
                                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                            >
                                                {{ $t('messages.last_names') }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                {{ student.last_name }} {{ student.second_last_name }}
                                            </td>
                                        </tr>

                                        <!-- More rows... -->

                                        <tr>
                                            <td
                                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                            >
                                                {{ $t('messages.group') }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                {{ student.group.name }}
                                            </td>
                                        </tr>

                                        <!-- More rows... -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--        Widgets section-->
        <DashboardStudentWidgets :widgets="widgets" />
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import DashboardStudentWidgets from '@/components/DashboardStudentWidgets.vue';

export default {
    layout: Layout,
    name: 'Show',
    components: {
        DashboardStudentWidgets,
    },
    props: ['student', 'widgets', 'meta'],
};
</script>
<style scoped>
p.prose {
    max-width: 100%;
}
.tw-glass {
    @apply bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-60 border border-gray-200;
}
</style>
